<template>
  <div>
    <v-navigation-drawer
      ref="customiseDrawer"
      v-model="value"
      app
      right
      temporary
      class="v-navigation-drawer--width-max drawer-customise-cover__container"
      stateless
    >
      <div class="drawer-container d-flex flex-column justify-space-between">
        <div
          class="pt-8 px-6 pb-6 drawer-header d-flex nav-header__wrapper align-center justify-space-between fixed-section__wrapper"
        >
          <h3 class="font-28 font-weight-bold">Customise your cover</h3>
          <v-btn
            icon
            @click="closeDrawer"
            class="btn-close"
            aria-label="Close drawer"
          >
            <v-icon class="icon--black" size="32">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <div>
          <div v-if="isRefreshingCover" class="overlay"></div>
          <div
            class="drawer-main flex-grow-1 px-1 px-xl-3 customise-cover-drawer"
          >
            <div
              class="d-flex bg-blue-50 ma-2 pa-3 align-center rounded"
              :class="!$vuetify.breakpoint.mobile ? 'cover-info' : ''"
            >
              <v-icon size="24" color="var(--blue-500)" class="my-2 mr-2 ml-1"
                >mdi-information</v-icon
              >
              <span style="max-width: 287px" class="my-2">
                We are showing you policies with
                <span class="font-weight-bold">{{ coverType }}</span> cover.
              </span>
              <div class="flex-grow-1"></div>
              <BaseButton
                text="Edit cover"
                flat
                link
                icon="mdi-pencil"
                depressed
                color="#4d7fb8"
                ripple
                small
                class="font-weight-600 px-1 d-flex align-self-center my-2"
                :class="!$vuetify.breakpoint.mobile ? 'mr-3' : ''"
                @click="editCover"
              />
            </div>
            <div class="mb-11 ml-7 mr-7" id="Buildings_Insurance">
              <div :class="$vuetify.breakpoint.mobile ? 'pt-5' : ''">
                <h4
                  class="font-20 mb-8"
                  :class="!$vuetify.breakpoint.mobile ? 'mt-9' : ''"
                >
                  Buildings Insurance
                  <v-icon
                    color="#106175"
                    size="15"
                    class="text-cursor"
                    @click="
                      showModal('DialogLandLordsContentBuildingInsurance')
                    "
                    >mdi-help-circle</v-icon
                  >
                </h4>
                <div class="d-flex justify-space-between">
                  <v-icon
                    size="20"
                    class="mt-1 align-self-start mr-1"
                    color="#1d8649"
                    >mdi-check-circle</v-icon
                  >
                  <p class="mb-7 font-18">
                    This policy provides
                    <span class="font-weight-bold"
                      >£1,000,000 buildings cover</span
                    >
                    as standard. The sum insured must cover the cost of
                    rebuilding your home.
                  </p>
                </div>
                <div
                  class="d-flex flex-column flex-lg-row align-xl-center justify-lg-space-between"
                  :class="$vuetify.breakpoint.mobile ? 'mb-9' : 'mb-10'"
                >
                  <div
                    class="flex-wrap flex-basis-58"
                    :class="
                      $vuetify.breakpoint.lgAndUp ? 'paragraph-width' : ''
                    "
                  >
                    <p class="font-16 font-weight-regular mb-0">
                      Choose your buildings cover excess
                    </p>
                  </div>
                  <BaseMoneySpinner
                    :minusDataUiid="'minusDataUiid_ExcessBuildings'"
                    :plusDataUiid="'plusDataUiid_ExcessBuildings'"
                    :inputDataUiid="'inputDataUiid_ExcessBuildings'"
                    :small="$vuetify.breakpoint.lgAndUp ? true : false"
                    :config="configExcess"
                    v-model="form.excessBuildings.Value"
                    class="mt-5 mt-xl-0 pa-0 flex-grow-1"
                    :class="$vuetify.breakpoint.lgAndUp ? 'spinner' : ''"
                  />
                </div>

                <div
                  class="d-flex flex-column flex-lg-row justify-lg-space-between"
                >
                  <div class="d-flex flex-column left-panel__toggle-button">
                    <p
                      class="ma-0 pr-lg-6 pr-0 font-16 font-weight-regular"
                      :class="
                        $vuetify.breakpoint.lgAndUp ? 'paragraph-width' : ''
                      "
                    >
                      Would you like to add extra accidental damage cover for
                      buildings?
                    </p>
                  </div>
                  <div class="pa-0 d-flex align-center mt-5 mt-lg-0">
                    <BaseToggleButton
                      :toggleButtonText="{
                        yesDataUiid: 'AccidentalDamageBuildings_Yes',
                        noDataUiid: 'AccidentalDamageBuildings_No',
                      }"
                      v-model="form.accidentalDamageBuildings.Value"
                      :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
                      :minWidth="$vuetify.breakpoint.lgAndUp ? '110px' : '100%'"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="mb-8 ml-6 mr-7"
              id="Contents_Insurance"
              v-if="includeContentCover"
            >
              <div>
                <h4 class="font-20 mb-4">
                  Contents Insurance
                  <v-icon
                    color="#106175"
                    size="15"
                    class="text-cursor"
                    @click="showModal('DialogLandLordsContentContentInsurance')"
                    >mdi-help-circle</v-icon
                  >
                </h4>
                <div
                  class="d-flex flex-column flex-lg-row align-xl-center justify-lg-space-between"
                  :class="$vuetify.breakpoint.mobile ? 'mb-3' : 'mb-8'"
                >
                  <div
                    class="d-flex flex-column flex-basis-58 mr-lg-2"
                    :class="
                      $vuetify.breakpoint.lgAndUp ? 'paragraph-width' : 'mb-5'
                    "
                  >
                    <p class="mb-2 font-16 font-weight-regular">
                      What amount of contents insurance is required?
                    </p>
                  </div>
                  <BaseMoneySpinner
                    :minusDataUiid="'minusDataUiid_LandlordContentsLevel'"
                    :plusDataUiid="'plusDataUiid_LandlordContentsLevel'"
                    :inputDataUiid="'inputDataUiid_LandlordContentsLevel'"
                    :small="$vuetify.breakpoint.lgAndUp ? true : false"
                    v-model="form.landlordContentsLevel.Value"
                    :config="configContentsLevel"
                    class="mt-3 mt-xl-0 mb-xl-2 pa-0 flex-grow-1"
                    :class="$vuetify.breakpoint.lgAndUp ? 'spinner' : 'mb-4'"
                  />
                </div>

                <div
                  class="d-flex flex-column flex-lg-row align-xl-center mb-10 justify-lg-space-between"
                >
                  <div
                    class="d-flex flex-column flex-basis-58 mr-lg-2"
                    :class="
                      $vuetify.breakpoint.lgAndUp ? 'paragraph-width' : ''
                    "
                  >
                    <p class="ma-0 pr-lg-6 pr-0 font-16 font-weight-regular">
                      Choose your contents cover excess
                    </p>
                  </div>
                  <BaseMoneySpinner
                    :minusDataUiid="'minusDataUiid_ExcessContents'"
                    :plusDataUiid="'plusDataUiid_ExcessContents'"
                    :inputDataUiid="'inputDataUiid_ExcessContents'"
                    :small="$vuetify.breakpoint.lgAndUp ? true : false"
                    :config="configExcess"
                    v-model="form.excessContents.Value"
                    class="mt-5 mt-xl-0 pa-0 flex-grow-1"
                    :class="$vuetify.breakpoint.lgAndUp ? 'spinner' : ''"
                  />
                </div>

                <div
                  class="d-flex flex-column flex-lg-row justify-lg-space-between"
                  :class="$vuetify.breakpoint.lgAndUp ? 'mb-15' : ''"
                >
                  <div class="d-flex flex-column left-panel__toggle-button">
                    <p
                      class="ma-0 pr-lg-6 pr-0 font-16 font-weight-regular mb-1"
                      :class="
                        $vuetify.breakpoint.lgAndUp ? 'paragraph-width' : ''
                      "
                    >
                      Would you like to add extra accidental damage cover for
                      contents?
                    </p>
                  </div>
                  <div class="pa-0 d-flex align-center mt-5 mt-lg-0">
                    <BaseToggleButton
                      :toggleButtonText="{
                        yesDataUiid: 'AccidentalDamageContents_Yes',
                        noDataUiid: 'AccidentalDamageContents_No',
                      }"
                      v-model="form.accidentalDamageContents.Value"
                      :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
                      :minWidth="$vuetify.breakpoint.lgAndUp ? '110px' : '100%'"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="ml-6 mr-7">
              <h3
                class="font-weight-bold font-20"
                :class="
                  $vuetify.breakpoint.mobile ? 'mb-3' : 'additional-cover mb-5'
                "
              >
                Would you like to boost your cover?
                <v-icon
                  v-if="$vuetify.breakpoint.mobile"
                  color="#106175"
                  size="15"
                  class="text-cursor"
                  @click="
                    showModal('DialogLandLordsContentAdditionalCoverOptions')
                  "
                  >mdi-help-circle</v-icon
                >
              </h3>
              <p :class="$vuetify.breakpoint.mobile ? 'mb-8' : 'mb-5'">
                You can choose to add optional extras to your policy to give you
                even more protection. Adding landlord’s emergency cover or legal
                expenses cover to your Landlord’s Insurance can be cheaper than
                getting them separately.
              </p>

              <div class="addOn__wrapper">
                <h4 v-if="$vuetify.breakpoint.mobile" class="font-20 mb-5">
                  Additional cover options
                </h4>

                <DrawerCustomiseCoverContentAdditionalCoverOptions
                  :addOns="ADD_ONS_LANDLORDS_D2C"
                  :productGroup="LANDLORDS"
                />
              </div>
            </div>
          </div>
          <div
            class="py-6 refresh-quote nav-footer__wrapper fixed-section__wrapper px-6 px-lg-11"
          >
            <BaseButton
              text="REFRESH QUOTES"
              height="68"
              block
              color="#106175"
              class="font-weight-bold font-20 rounded-pill px-10 white--text"
              type="submit"
              iconSize="30"
              icon="mdi-refresh"
              :loading="isRefreshingCover"
              loadingIconColor="white"
              :disabled="isRefreshingCover"
              @click="getQuote"
            />
          </div>

          <EligibilityBaseDialog
            ref="dialogLoading"
            :windowClass="'confirm-dialog'"
          >
            <template v-slot:content="{ title }">
              <EligibilityLoading :title="title" insurance-title="Landlord's" />
            </template>
          </EligibilityBaseDialog>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { LANDLORDS } from "@/constants/questionset.constants";
import { formatCoverType, includesContents } from "@/common/answers";
import { wordsToNumbers } from "@/common/answers.js";
import { dereference } from "@/common/transforms";
import {
  convertToBool,
  prepareDataForGetQuote,
  resetEligibilityCheck,
  scrollTop,
} from "@/common/utils";
import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import BaseMoneySpinner from "@/components/BaseComponents/BaseMoneySpinner.vue";
import BaseToggleButton from "@/components/BaseComponents/BaseToggleButton.vue";
import EligibilityBaseDialog from "@/components/EligibilityBaseDialog.vue";
import { CONFIG_EXCESS_D2C } from "@/constants/excess-config.constants";
import { CONFIG_LANDLORD_CONTENTS_LEVEL } from "@/constants/contents-config.constants";
import { COVER_DETAILS_FORM } from "@/constants/form.constants";
import { DIALOG_MODULE, QUESTIONS_MODULE } from "@/store/types/module-types";
import EligibilityLoading from "@/views/Dialog/EligibilityLoading.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import DrawerCustomiseCoverContentAdditionalCoverOptions from "@/components/QuoteResult/landlords/DrawerCustomiseCoverContentAdditionalCoverOptions.vue";
import { ADD_ONS_LANDLORDS_D2C } from "@/constants/additional-cover-options";

export default {
  name: "D2CLandlordCoverDetailsPage",
  components: {
    BaseButton,
    BaseMoneySpinner,
    BaseToggleButton,
    EligibilityBaseDialog,
    EligibilityLoading,
    DrawerCustomiseCoverContentAdditionalCoverOptions,
  },

  props: {
    value: Boolean,
  },

  data() {
    return {
      configExcess: CONFIG_EXCESS_D2C,
      configContentsLevel: CONFIG_LANDLORD_CONTENTS_LEVEL,
      form: COVER_DETAILS_FORM,
      isRefreshingCover: false,
      ADD_ONS_LANDLORDS_D2C,
      LANDLORDS,
    };
  },

  computed: {
    ...mapState(QUESTIONS_MODULE, ["questionMap", "coverAnswers"]),

    coverType() {
      return formatCoverType(this.questionMap["CoverType"].Value);
    },

    includeContentCover() {
      return includesContents(this.questionMap["CoverType"]);
    },

    isSelectedRentGuarantee() {
      return this.form.rentGuarantee.Value;
    },

    isSelectedLegalExpenses() {
      return this.form.legalExpenses.Value;
    },
  },

  beforeMount() {
    this.initDataFromQuoteResponse();
    scrollTop();
  },

  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "getQuotes",
      "setCoverSelection",
      "setCoverAnswers",
    ]),
    ...mapMutations(DIALOG_MODULE, ["showModal"]),

    closeDrawer() {
      prepareDataForGetQuote(this.form, this.questionMap);
      this.$emit("closeDrawer");
    },

    editCover() {
      prepareDataForGetQuote(this.form, this.questionMap);
      resetEligibilityCheck(this.form);
      this.$router.push("/d2c/landlords/cover");
    },

    getQuote() {
      if (this.isRefreshingCover) return;
      this.isRefreshingCover = true;
      const quoteRequestFields = {
        IsPartialQuote: false,
      };

      prepareDataForGetQuote(this.form, this.questionMap);
      resetEligibilityCheck(this.form);
      this.questionMap.LandlordsEligibility.Value = true;
      if (!this.form.rentGuarantee?.Value && !this.form.legalExpenses?.Value) {
        this.questionMap.NewLetOrProductTransfer.Value = "";
        const keysToRemove = [
          "LegalExpenses",
          "RentGuarantee",
          "AddOnEligibility",
          "NewLetOrProductTransfer",
        ];
        this.setCoverAnswers(
          this.coverAnswers.filter(
            (a) => !keysToRemove.includes(a.InterfaceKey)
          )
        );
      }

      this.getQuotes(quoteRequestFields)
        .then(() => {
          this.setCoverSelection({
            buildingsAd: this.form.accidentalDamageBuildings.Value,
            contentsAd: this.form.accidentalDamageContents.Value,
          });
          this.isRefreshingCover = false;
          this.closeDrawer();
          scrollTop();
        })
        .catch(() => {
          this.isRefreshingCover = false;
        });
    },

    initDataFromQuoteResponse() {
      this.form.accidentalDamageBuildings =
        this.questionMap.AccidentalDamageBuildings;
      if (this.form.accidentalDamageBuildings) {
        this.form.accidentalDamageBuildings.Value = convertToBool(
          this.form.accidentalDamageBuildings.Value
        );
      }

      this.form.excessBuildings = dereference(this.questionMap.ExcessBuildings);
      if (!this.form.excessBuildings.Value) {
        this.form.excessBuildings.Value = this.configExcess.default;
      } else {
        this.form.excessBuildings.Value = wordsToNumbers(
          this.form.excessBuildings.Value
        );
      }

      if (this.includeContentCover) {
        this.form.landlordContentsLevel = dereference(
          this.questionMap.LandlordContentsLevel
        );
        if (!this.form.landlordContentsLevel.Value) {
          this.form.landlordContentsLevel.Value =
            this.configContentsLevel.default;
        } else {
          this.form.landlordContentsLevel.Value = wordsToNumbers(
            this.form.landlordContentsLevel.Value
          );
        }

        this.form.excessContents = dereference(this.questionMap.ExcessContents);
        if (!this.form.excessContents.Value) {
          this.form.excessContents.Value = this.configExcess.default;
        } else {
          this.form.excessContents.Value = wordsToNumbers(
            this.form.excessContents.Value
          );
        }

        this.form.accidentalDamageContents = dereference(
          this.questionMap.AccidentalDamageContents
        );
        if (this.form.accidentalDamageContents) {
          this.form.accidentalDamageContents.Value = convertToBool(
            this.form.accidentalDamageContents.Value
          );
        }
      }

      this.form.rentGuarantee = this.questionMap.RentGuarantee;
      if (this.form.rentGuarantee) {
        this.form.rentGuarantee.Value = convertToBool(
          this.form.rentGuarantee.Value
        );
      }
      this.form.legalExpenses = this.questionMap.LegalExpenses;
      if (this.form.legalExpenses) {
        this.form.legalExpenses.Value = convertToBool(
          this.form.legalExpenses.Value
        );
      }
      this.form.landlordsEmergency = this.questionMap.LandlordsEmergency;
      if (this.form.landlordsEmergency) {
        this.form.landlordsEmergency.Value = convertToBool(
          this.form.landlordsEmergency.Value
        );
      }

      this.form.addonEligibility = this.questionMap.AddOnEligibility;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/d2c/cover-detail.scss";
.drawer-customise-cover__container {
  height: 100% !important;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  z-index: 9999;
}
.drawer-container {
  height: 100%;
  color: #272727;
}
.customise-cover-drawer {
  padding-bottom: 113px;
  padding-top: 121px;
}

.refresh-quote {
  bottom: 0;
}

.nav-header__wrapper {
  border-bottom: 0.5px solid #b4b4b4;
  :deep(.v-icon) {
    height: 32px;
    width: 32px;
    &.icon--black {
      color: #272727;
    }
  }
}

.nav-footer__wrapper {
  border-top: 0.5px solid #b4b4b4;
}

:deep(.fixed-section__wrapper) {
  position: fixed;
  width: 100%;
  transform: translate3d(0, 0, 0);
  background-color: #fff;
  z-index: 2;
  margin-right: 0;
  right: 0;
  &.bottom-0 {
    bottom: 0;
  }
  .col {
    padding-left: 0;
    padding-right: 0;
  }
}
.rounded {
  border-radius: 10px !important;
}
.cover-info {
  max-width: 602px;
}
.paragraph-width {
  max-width: 272px;
}
.spinner {
  max-width: 236px;
}
.gap {
  gap: 100px;
}
.border-1 {
  border: solid 1px #7c869a;
}
.additional-cover {
  height: 32px;
}
:deep(.base-toggle-container) {
  flex-wrap: nowrap;
}
:deep(.flex-no-wrap) {
  flex-wrap: nowrap;
}
@media screen and (min-width: ($grid-breakpoints-lg - 1)) {
  .customise-cover-drawer {
    padding-top: 94px;
  }

  .refresh-quote {
    .v-btn:not(.v-btn--round).v-size--default {
      min-width: 574px !important;
    }
  }
}
</style>
